import { useEffect, useState } from 'react';
import mermaid from 'mermaid';
import DOMPurify from 'dompurify';
import { MermaidProps } from './props';
import React from 'react';

let diagramId = 0;

const makeDiagram = async (el: HTMLElement, diagramText: string) => {
  el.style.display = 'none';

  const diagramElement = document.createElement('div');
  diagramElement.className = 'mermaid';

  el.parentNode?.insertBefore(diagramElement, el.nextSibling);

  const id = `mermaid-${diagramId++}`;

  try {
    const { svg } = await mermaid.render(id, diagramText);
    diagramElement.innerHTML = svg;
    return svg;
  } catch (err) {
    const message =
      err instanceof Error ? err.message : 'Invalid Mermaid syntax';
    diagramElement.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="600" height="120">
      <rect width="100%" height="100%" fill="#fff5f5" stroke="#dc2626"/>
      <text x="20" y="35" font-family="sans-serif" font-size="18" fill="#dc2626">
        Cannot render the Mermaid diagram
      </text>
      
      <text x="20" y="65" font-family="monospace" font-size="12" fill="#444">
        ${message.replace(/[<&>]/g, '')}
      </text>
    </svg>
  `;
  }
  return diagramElement.innerHTML;
};

interface MermaidAddonProps {
  retrievedContent: string;
  mermaidProps?: MermaidProps;
}

export const MermaidAddon: React.FC<MermaidAddonProps> = ({
  retrievedContent,
}) => {
  const [response, setResponse] = useState<any>();
  useEffect(() => {
    mermaid.initialize({ securityLevel: 'strict', startOnLoad: true });

    const renderMermaid = async () => {
      const svg = await makeDiagram(
        document.createElement('div'),
        retrievedContent,
      );
      const sanitizedSvg = DOMPurify.sanitize(svg, {
        USE_PROFILES: { svg: true, svgFilters: true },
      });
      setResponse(sanitizedSvg);
      return sanitizedSvg;
    };
    renderMermaid();
  }, [retrievedContent]);
  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: response }} />
    </div>
  );
};
